export default __webpack_public_path__ + "static/media/1134.b6d14093.png";